import { render } from "./Electrocardiogram.vue?vue&type=template&id=39d38362&scoped=true"
import script from "./Electrocardiogram.vue?vue&type=script&lang=js"
export * from "./Electrocardiogram.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d38362"]])

export default __exports__